import { useMutation } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import { extractDownloadData } from "../../presignedDownload";
import type { PresignedDownloadData } from "../../presignedDownload";
import { buildReportingDownloadPath } from "./reportingPaths";

export type MintReportingDownloadInput = {
  runId: string;
  key: string;
};

export const mintReportingDownload = async ({
  runId,
  key,
}: MintReportingDownloadInput): Promise<PresignedDownloadData> => {
  const response = await createRegulatorPortalInstance().post(
    buildReportingDownloadPath(runId),
    { key },
  );
  const data = extractDownloadData(response);
  if (!data) {
    throw new Error("missing_download_url");
  }
  return data;
};

export const useMintReportingDownload = (): UseMutationResult<
  PresignedDownloadData,
  Error,
  MintReportingDownloadInput
> =>
  useMutation({
    mutationKey: ["regulator-portal", "reporting-download"],
    mutationFn: mintReportingDownload,
  });
